import Link from 'next/link'
import { useEffect, useState } from 'react'
import { Button, useUI } from '@components/ui'
import Cookies from 'js-cookie'
type CartReturnToLastCollectionCookie = {
  handle: string
  title: string
}
export default function ContinueShoppingButton() {
  const { toggleSidebar } = useUI()
  const [collection, setCollection] =
    useState<CartReturnToLastCollectionCookie | null>(null)
  useEffect(() => {
    const stored = Cookies.get('cartReturnToLastCollection')
    if (stored) {
      try {
        setCollection(JSON.parse(stored))
      } catch (err) {
        console.error('Invalid cartReturnToLastCollection cookie data:', err)
      }
    }
  }, [])
  if (!collection || !collection.handle) {
    return null
  }
  return (
    // <div className="px-4 sm:px-6 mb-6">
    <Link
      href={`/collections/${collection.handle}`}
      onClick={() => {
        toggleSidebar()
      }}
    >
      <Button
        style={{
          paddingTop: '16px',
          paddingBottom: '16px',
          lineHeight: '16px',
          fontSize: '13px',
          height: '48px',
        }}
        variant="ghost"
        width="100%"
        className="flex flex-col mt-2 mb-2"
      >
        Continue shopping
        {/*<strong>{collection.title}</strong>*/}
      </Button>
    </Link>
    // </div>
  )
}
